// Decides whether the user should be routed to the catalog purchase page for a
// registration link, and returns that path (or null if no purchase is needed).
//
// The gate is keyed on the link VALUE, not on `me.registrationLinkUsed`, so it
// behaves identically whether the link was set on the user (new anonymous
// user) or merely applied via add-link for an already-signed-in user (where
// `registrationLinkUsed` stays null). Callers pass the link value they are
// currently acting on; when none is available it falls back to the user's
// last-used link.
async function catalogPurchaseTarget(store, me, linkId) {
  const usedLink = (me && me.registrationLinkUsed) || null;
  const id = linkId
    || (usedLink && usedLink.link)
    || (usedLink && usedLink._id)
    || null;
  if (!id) return null;

  // Resolve the link by value so we know whether it actually carries a
  // catalog. (getRegistrationLinkByLink looks the link up by its `link`
  // string; the fallback `usedLink._id` only works if the value equals the
  // id, which is the case for auto-generated links.)
  let link = null;
  try {
    link = await store.dispatch('getRegistrationLinkByLink', id);
  } catch (e) {
    link = null;
  }

  const catalog = (link && Array.isArray(link.catalog)) ? link.catalog : [];
  if (catalog.length === 0) return null;

  // If they've already paid for the catalog, there's nothing to purchase.
  let purchased = false;
  try {
    purchased = await store.dispatch('hasPurchasedCatalog', { registrationLinkId: id });
  } catch (e) {
    purchased = false;
  }

  return purchased ? null : `/purchase/catalog/${encodeURIComponent(id)}`;
}

export default catalogPurchaseTarget;



// WEBPACK FOOTER //
// ./src/utils/catalog.js